import { atom } from "recoil";

const IsSearchingAtom = atom<boolean>({
    default: false,
    key: 'isSearchingFlightsAtomKey'
})

export default IsSearchingAtom;